import * as FilePond from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import "filepond/dist/filepond.css"
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';

class FileUpload {
    init() {
        this.$fileUpload = $("#initiative-file-upload");

        if (!this.$fileUpload.length) {
            return;
        }

        let temporaryDocuments = JSON.parse(this.$fileUpload.attr("documents"));

        FilePond.registerPlugin(FilePondPluginFileValidateSize);
        FilePond.registerPlugin(FilePondPluginFileValidateType);
        FilePond.registerPlugin(FilePondPluginGetFile);

        let options = {
            maxFileSize: "3MB",
            allowMultiple: true,
            name: 'filepond',
            labelIdle: 'Ziehen Sie Ihre Dokumente hier hinein oder <span class="filepond--label-action">Durchsuchen</span> Sie Ihr Gerät',
            server: {
                process: '/initiative/file/upload',
                revert: '/initiative/file/delete',
                restore: '/initiative/file/load/'
            },
            maxFiles: 6,
            labelMaxFileSizeExceeded: "Das Dokument ist zu groß",
            labelMaxFileSize: "Die maximale Dateigröße beträgt {filesize}",
            labelFileLoading: "Dokument wird geladen",
            labelFileLoadError: "Fehler beim Laden des Dokuments",
            labelFileProcessing: "Dokument wird hochgeladen",
            labelFileProcessingComplete: "Upload des Dokuments abgeschlossen",
            labelFileProcessingAborted: "Upload des Dokuments abgebrochen",
            labelFileProcessingError: "Fehler beim Upload des Dokuments",
            labelFileRemoveError: "Fehler beim Löschen des Dokuments",
            labelTapToCancel: "Zum Abbrechen drücken",
            labelTapToRetry: "Nochmal versuchen",
            labelTapToUndo: "",
            labelButtonRemoveItem: "Dokument löschen",
            labelButtonAbortItemLoad: "Abbrechen",
            labelButtonRetryItemLoad: "Erneut versuchen",
            labelButtonAbortItemProcessing: "Abbrechen",
            labelButtonRetryItemProcessing: "Erneut versuchen",
            labelButtonProcessItem: "Hochladen",
            allowDownloadByUrl: true,
            labelButtonDownloadItem: 'Datei herunterladen'
        };

        FilePond.setOptions(options);

        let files = [];
        if (Array.isArray(temporaryDocuments) && temporaryDocuments.length > 0) {
            temporaryDocuments.forEach(documentId => files.push({
                source: documentId,
                options: {
                    type: 'limbo'
                }
            }));
        }

        FilePond.create(this.$fileUpload.get(0), {files: files});
    }
}

export default FileUpload;